
















































import http from "@/axios/http-common";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";

interface ItemObat {
  type: "single";
  obat_nama: string;
  qty: number;
  qty_unit: string;
  // harga: number;
  // countedHarga: number;
  obat_id: string;
  // ap_frekuensi: string;
  // ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  aturan_pakai: {
    id: string;
    nama: string;
  };
}

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
});

@Component
export default class ObatItemResep extends Vue {
  public rules = {
    required: (value) => !!value || "Kolom ini harus diisi",
  };
  loading = false;
  items = [];
  val = "";
  // cekAturanPakai(val) {
  //   if (val) {
  //     return { id: val.ap_template_id, nama: val.ap_template_nama };
  //   } else {
  //     return { id: null, nama: null };
  //   }
  // }
  listAturanPakai = [];
  // search = null;
  select = null;
  // list = [{ val: null, search: null }];
  entries = [];
  signaLoading = false;
  _timerId;
  searchString = null;

  @Prop() item: ItemObat;

  @Prop() index: number;

  @Prop() color: string;

  @Ref() qty: HTMLInputElement;

  mounted() {
    this.$nextTick(() => {
      this.qty.focus();
    });
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  // countHarga(item: ItemObat) {
  //   item.countedHarga = item.qty * item.harga;
  //   this.$emit("sum-total-harga");
  // }

  // triggerSubmit() {
  //   this.$emit("trigger-submit");
  // }

  removeItem(index) {
    this.$emit("remove-item", index);
  }

  @Watch("searchString")
  searched() {
    this.listAturanPakai = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchAturanPakai(this.searchString);
    }, 500);
  }
  searchAturanPakai(termSearch) {
    http
      .getDataParam(`/aturan-pakai/search`, {
        params: { term: termSearch },
      })
      .then((res) => {
        this.listAturanPakai = res.data;
      })
      .finally();
  }

  changeAturanPakai(val) {
    if (val) {
      this.item.ap_template_nama = this.item.aturan_pakai.nama;
      this.item.ap_template_id = this.item.aturan_pakai.id;
    }
  }
}
